<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0">
      <div class="flex justify-start items-center">
        <input class="w-64 ml-3 form-input" v-model="createSecret.value" placeholder="värde..." />
        <input class="w-64 ml-3 form-input" v-model="createSecret.description" @keyup.enter="onAdd" placeholder="beskrivning..." />
      </div>
      <table class="mt-5 mb-20 table-fixed w-auto">
        <tr class="border-b">
          <td class="w-56 px-4 py-2 text-gray-600 uppercase">typ</td>
          <td class="px-4 py-2 text-gray-600 uppercase">värde</td>
          <td class="px-4 py-2 text-gray-600 uppercase">beskrivning</td>
          <td class="px-4 py-2 text-gray-600 uppercase">upphör</td>
          <td class="w-20 px-4 py-2" />
        </tr>

        <tbody>
          <tr v-for="s in current.clientSecrets" :key="s.id" class="bg-white">
            <td class="px-4 py-2 text-gray-900">
              {{s.type}}
            </td>
            <td class="px-4 py-2 text-gray-900">
              {{s.value}}
            </td>
            <td class="px-4 py-2 text-gray-900">
              {{s.description}}
            </td>
            <td class="px-4 py-2 text-gray-900">
              {{s.expiration}}
            </td>
            <td class="w-32 px-4 py-2 text-center align-middle">
              <button class="bg-transparent focus:outline-none" @click="onRemove(s)">
                <svg fill="currentColor" viewBox="0 0 20 20" class="w-6 h-6 text-red-500">
                  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "clientsecrets",
  data() {
    return {
      createSecret: {
        type: "SharedSecret",
        value: "",
        description: ""
      }
    };
  },

  computed: {
    ...mapGetters("clientsStore", ["current"])
  },

  methods: {
    ...mapActions("clientsStore", ["addSecret", "removeSecret"]),
    async onAdd() {
      await this.addSecret(this.createSecret);
    },
    async onRemove(secret) {
      await this.removeSecret(secret);
    }
  }
};
</script>
